import { Component, OnInit, Input, Renderer2, ElementRef} from '@angular/core';

// env
import { environment } from '../../../environments/environment';

// service
import { GlobalService } from '../../shared/service/global.service';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-tab-sustainable',
  templateUrl: './tab-sustainable.component.html'
})
export class TabSustainableComponent implements OnInit {

  @Input() dataTabSustain;
  apiAsset = environment.API_ASSETS;
  @Input() curData;
  @Input() curDataDesc;
  isLang;

  constructor(
    private globalService : GlobalService,
    private renderer: Renderer2,
    private elem: ElementRef,
    private apiService: ApiService
  ) {  }

  ngOnInit(): void {
    //MultiLanguage
   this.isLang =  this.apiService.isLang();
  }

  changeOverview(data, ev){
      this.curData = data;
      this.curDataDesc = this.globalService.trimString2(data.section.content, 150);
      const target = ev.currentTarget;
      const elements = this.elem.nativeElement.querySelectorAll('.tab-sustainable .icon-sus');
      let i;
      for(i=0;i<elements.length;i++) {
        this.renderer.removeClass(elements[i], 'active');
      }
      this.renderer.addClass(target, 'active');
  }

}
